import { client } from "api";
import { Company } from "models/Company";
import { CompanyContact } from "models/CompanyContact";

export type UpdateContactRequest = { companyId: Company["id"] } & CompanyContact;

export type UpdateContactResponse = CompanyContact[];

export const updateContact = ({ companyId, id, name, email, phone }: UpdateContactRequest) =>
  client.put<UpdateContactResponse>(`/company/${companyId}/contacts/${id}`, { name, email, phone }).then((res) => res.data);
